module.exports = "/images/icon-calendar-day.svg?ae92282b976180b0ab55cbba513c7283";